/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Servis_S9_HeadingInputs */

const tr_servis_s9_heading = /** @type {(inputs: Servis_S9_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`9. Üçüncü Taraf Hizmetleri`)
};

const en_servis_s9_heading = /** @type {(inputs: Servis_S9_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`9. Third Party Services`)
};

const de_servis_s9_heading = /** @type {(inputs: Servis_S9_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`9. Dienste Dritter`)
};

const ru_servis_s9_heading = /** @type {(inputs: Servis_S9_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`9. Услуги третьих лиц`)
};

/**
* | output |
* | --- |
* | "9. Third Party Services" |
*
* @param {Servis_S9_HeadingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const servis_s9_heading = /** @type {((inputs?: Servis_S9_HeadingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Servis_S9_HeadingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_servis_s9_heading(inputs)
	if (locale === "de") return de_servis_s9_heading(inputs)
	if (locale === "ru") return ru_servis_s9_heading(inputs)
	return tr_servis_s9_heading(inputs)
});